// extracted by mini-css-extract-plugin
module.exports = {"covid_callout":"covid_callout-3Q9","content":"content-KTT","arrow_container":"arrow_container-3xj"};